import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {AngularFireAuth} from 'angularfire2/auth';
import {Router} from '@angular/router';

@Injectable()
export class AuthService {

  constructor(
      public router: Router,
      public afAuth: AngularFireAuth) {}

  /**
   * @param email
   * @param password
   */
  public login(email: string, password: string) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password)
  }

  /**
   * logout
   */
  public logout() {
    this.afAuth.auth.signOut()
      .then(() => {
        this.router.navigateByUrl('/auth');
      })
      .catch(err => {
        console.log(err);
      });
  }

    /**
     * get current signed in user
     * @returns {firebase.auth.Auth}
     */
  getSignedInUser(){
    return this.afAuth.auth;
  }

  getUser(){
      return this.afAuth.authState;
  }
    /**
     * send reset password email
     * @param email
     * @returns {firebase.Promise<any>}
     */
  sendResetPasswordEmail(email: string) {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

  setNewPassword(token: string, new_password: string){
      return this.afAuth.auth.confirmPasswordReset(token, new_password);
  }

  checkToken(token: string){
      return this.afAuth.auth.verifyPasswordResetCode(token);
  }
}



// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/auth.service.ts